<template lang="pug">
.flex-box
  el-select(filterable, v-bind="$attrs", v-on="$listeners")
    el-option(v-for="{ dicCode, dicName, label } in rootList", :key="dicCode", :value="dicCode", :label="label")
      span.code {{ dicCode }}
      span {{ dicName }}
  i.el-icon-refresh.icon-btn(@click="getAllDict(true)", title="点击刷新")
  i.el-icon-plus.icon-btn(@click="addDict(true)", title="添加字典")
</template>
<script>
import { getVfDictList } from "@/CommonDP/service/vf-component-service.js";
import { dict_cache, VF_DICT_ENUM } from "./index.js";
import asyncCom from "@/CommonDP/commons/asyncCom.js";
export default {
  data() {
    return { rootList: [] };
  },
  created() {
    this.getAllDict();
  },
  methods: {
    async addDict() {
      const { default: components } = await import("./add.vue");
      const dicCode = await asyncCom(components);
      this.$message.success("添加成功");
      await this.getAllDict(true);
      this.$emit("input", dicCode);
      this.$emit("change", dicCode);
    },
    async getAllDict(force = false) {
      const key = VF_DICT_ENUM.root;
      this.rootList = [];
      if (force) dict_cache[key] = undefined;
      const fetch = dict_cache[key] || getVfDictList();
      dict_cache[key] = fetch;
      const { data } = await fetch;
      this.rootList = data.map(({ dicCode, dicName }) => ({ dicCode, dicName, label: `${dicCode}-${dicName}` }));
    }
  }
};
</script>
<style lang="scss" scoped>
.flex-box {
  display: flex;
  align-items: center;
  flex-flow: row nowrap;
  > .el-select {
    flex: 1 1;
  }
  > .el-button {
    flex: 0 0;
  }
}
.icon-btn {
  font-size: 18px;
  margin: 0 4px;
  cursor: pointer;
  transition: color 0.2s;
  &:hover {
    color: #4777e7;
  }
}
</style>
